export default __webpack_public_path__ + "static/media/jasperactive-main-logo.cd6ee422.svg";